<template>
  <IconLucideSettings2 />
</template>
